import React from "react";
import NavbarHome from "../components/navbar-home";
import GaleryRegularContent from "../pages/Galerys/galery-regular-content";
import GaleryRegularJumbotron from "../pages/Galerys/galery-regular-jumbotron";
import Footer from "../components/footer";
import { useEffect } from "react";

export default function GaleryRegular() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <GaleryRegularJumbotron />
      <GaleryRegularContent />
      <Footer />
    </>
  );
}
